const LOCAL_STORAGE_KEY_PREFIX = "lookout-user-settings-"

export const JOB_RUN_LOGS_SHOW_TIMESTAMPS_KEY = `${LOCAL_STORAGE_KEY_PREFIX}job-run-logs-show-timestamps`
export const JOB_RUN_LOGS_TEXT_SIZE_KEY = `${LOCAL_STORAGE_KEY_PREFIX}job-run-logs-text-size`
export const JOB_RUN_LOGS_WRAP_LINES_KEY = `${LOCAL_STORAGE_KEY_PREFIX}job-run-logs-wrap-lines`

export const CODE_SNIPPETS_WRAP_LINES_KEY = `${LOCAL_STORAGE_KEY_PREFIX}code-snippets-wrap-lines`

export const FORMAT_TIMESTAMP_SHOULD_FORMAT_KEY = `${LOCAL_STORAGE_KEY_PREFIX}format-timestamp-should-format`
export const FORMAT_TIMESTAMP_TIME_ZONE_KEY = `${LOCAL_STORAGE_KEY_PREFIX}format-timestamp-time-zone`
export const FORMAT_TIMESTAMP_LOCALE_KEY = `${LOCAL_STORAGE_KEY_PREFIX}format-timestamp-locale`

export const FORMAT_NUMBER_SHOULD_FORMAT_KEY = `${LOCAL_STORAGE_KEY_PREFIX}format-number-should-format`
export const FORMAT_NUMBER_NOTATION_KEY = `${LOCAL_STORAGE_KEY_PREFIX}format-number-notation`
export const FORMAT_NUMBER_LOCALE_KEY = `${LOCAL_STORAGE_KEY_PREFIX}format-number-locale`

export const VISUAL_THEME_NAME_KEY = `${LOCAL_STORAGE_KEY_PREFIX}visual-theme-name`
export const VISUAL_THEME_CUSTOM_CONFIG_JSON_KEY = `${LOCAL_STORAGE_KEY_PREFIX}visual-theme-custom-config-json`
